import React, { useEffect, useState } from "react";
import classes from "../styles/Slider.module.css";
import { getClasses, pxToEm, toPrecision } from "../utils";

const Slider: React.FC<{
  orientation: "vertical" | "horizontal";
  visible: boolean;
  size: number; // height when vertical and width when horizontal
  ticknes: number; // width when vertical and height when horizontal
  value?: number; // the value of the slider if none is passed defaults to 0
  // the amount of value change on mouse scroll/per scroll movement/,
  // i.e. how sensitive is the slider to the scroll
  scrollStep?: number;
  onValueChange?: (value?: number) => void;
  onMouseLeave?: (e: any) => void;
  className?: string;
}> = ({
  visible,
  onMouseLeave,
  size,
  ticknes,
  className,
  onValueChange,
  value = 0,
  scrollStep = 0.001,
}) => {
  const width = ticknes;
  const height = size;
  const [sliderValue, setSliderValue] = useState(0);
  const [dragging, setDragging] = useState(-1);

  const setNewLevel = (value: number) => {
    const newLevel = toPrecision(Math.max(0, Math.min(1, value)));
    if (newLevel !== sliderValue) {
      setSliderValue(newLevel);
      onValueChange && onValueChange(newLevel);
    }
  };

  const barClick = (e: any) => {
    const rect = e.target.getBoundingClientRect();
    const y = e.clientY - rect.top;
    const newLevel = Math.floor((1 - y / rect.height) * 50) / 50;

    setNewLevel(newLevel);
  };

  const drag = (e: React.MouseEvent) => {
    if (dragging === -1) return;
    const levelChange = ((dragging - e.clientY) * (100 / height)) / 100;

    setDragging(e.clientY);
    setNewLevel(sliderValue + levelChange);
  };

  const startDrag = (e: React.MouseEvent) => setDragging(e.clientY);
  const stopDrag = () => setDragging(-1);
  const onMouseLeaveHandler = (e: React.MouseEvent) => {
    stopDrag();
    onMouseLeave && onMouseLeave(e);
  };

  useEffect(() => {
    if (!visible) stopDrag();
  }, [visible]);

  useEffect(() => {
    setSliderValue(value);
  }, [value]);

  useEffect(() => {
    if (!visible) return;
    const onWheel = (e: any) => {
      const delta = -e.deltaY * scrollStep;
      setNewLevel(sliderValue + delta);
    };
    window.addEventListener("wheel", onWheel);

    return () => window.removeEventListener("wheel", onWheel);
  });

  if (!visible) return null;

  return (
    <div
      className={getClasses(classes, "slider", className)}
      onMouseMove={drag}
      onMouseLeave={onMouseLeaveHandler}
      onMouseUp={stopDrag}
    >
      <div
        className={classes.inner}
        style={{ width: pxToEm(width), height: pxToEm(height) }}
      >
        <div className={classes.bar}>
          <div
            className={classes.head}
            style={{
              height: pxToEm(ticknes + 4),
              width: pxToEm(ticknes + 4),
              left: pxToEm(-2),
              borderRadius: pxToEm(ticknes + 4),
              top: 100 - sliderValue * 100 + "%",
            }}
            onMouseDown={startDrag}
          ></div>
          <div className={classes.empty}></div>
          <div
            className={classes.full}
            style={{ height: sliderValue * 100 + "%" }}
          ></div>
          <div className={classes.area} onClick={barClick}></div>
        </div>
      </div>
    </div>
  );
};

export default Slider;
